import React from 'react'

import ListContent from '../../../react4xp/components/ListContent'

import dayjs from 'dayjs';
import 'dayjs/locale/nb'

function ListContentPart({ title, type, contents, link }) {
  return (
    <ListContent
        title={title}
        content={type}
        articles={type == 'articles' 
            ? contents.map(content => {
                return {
                    ...content,
                    date: content.enonicDate ? dayjs(content.enonicDate).locale('nb').format('D. MMMM YYYY') : null,
                    src: content.image?.link,
                    srcMedium: content.imageMedium?.link,
                    alt: content.image?.alt
                }
            })
            : null}
        recipes={type == 'recipes' 
            ? contents.map(content => {
                return {
                    ...content,
                    src: content.image?.link,
                    srcMedium: content.imageMedium?.link,
                    alt: content.image?.alt
                }
            })
            : null}
        products={type == 'products' 
            ? contents.map(content => {
                return {
                    ...content,
                    src: content.image?.link,
                    srcMedium: content.imageMedium?.link,
                    alt: content.image?.alt
                }
            })
            : null}
        bottomLink={{
            href: link.url?.href,
            text: link.text,
            external: link.isExternal
        }}
    />
  )
}

export default (props) => <ListContentPart {...props} />
